<template>
  <div>
    <div>
      <el-button type="primary" @click="showDialog = true"
        >打开自定义弹窗</el-button
      >
      <el-button type="primary" @click="handleOpenLoaderWindow"
        >loader window</el-button
      >
    </div>
    <CustomDialog
      :visible="showDialog"
      title="自定义弹窗标题"
      :Comp="InnerContent"
      @close="showDialog = false"
      @confirm="handleConfirm"
      :width="'500px'"
    >
      <template #header>
        <div class="flex flex-row justify-between items-center p-4">
          <span style="font-weight: bold; font-size: 18px; color: #409eff"
            >自定义Header</span
          >
          <el-button type="text" @click="showDialog = false">
            <i class="el-icon-close" style="font-size: 18px"></i>
          </el-button>
        </div>
      </template>
      <template #default>
        <InnerWindow id="123" />
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "@/plugins/CustomDialog.vue";
import InnerWindow from "./InnerWindow.vue";

export default {
  name: "DemoCustomDialog",
  components: { CustomDialog, InnerWindow },
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    handleConfirm(data) {
      this.$message.success("确认事件: " + (data || "无数据"));
      this.showDialog = false;
    },
    async handleOpenLoaderWindow() {
      const result = await this.$loaderWindow({
        title: "Loader Window 示例",
        component: () => import("./InnerWindow.vue"),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        width: "500px",
        props: {
          id: "loader-123",
        },
      });
      this.$message.success("Loader window 关闭，返回数据: " + result);
    },
  },
  // 内部弹窗内容组件
  computed: {
    InnerContent() {
      return {
        functional: true,
        props: ["msg"],
        render(h, ctx) {
          return h("div", [
            h("div", ctx.props.msg),
            h(
              "el-button",
              {
                props: { type: "primary" },
                on: {
                  click: () => ctx.parent.$emit("confirm", "你点击了确认"),
                },
              },
              "确认"
            ),
          ]);
        },
      };
    },
  },
};
</script>
